<template>
   <el-dialog custom-class="dialog-wrapper" :title="dialogTitle" :close-on-click-modal="false" :modal-append-to-body="false"
      v-model="dialogVisible" @close="close">

      <el-form label-position="top">
         <el-form-item label="用户 ID">
            <div style="display: flex; align-items: center">
               <el-input v-model.trim="inputUid" placeholder="请输入用户 ID" clearable style="flex: 1; margin-right: 8px"
                  @keyup.enter="handleAddUid">
               </el-input>
               <el-button type="primary" @click="handleAddUid">添加</el-button>
            </div>
         </el-form-item>
         <el-form-item label="已添加的 UID">
            <div class="card-wrap">
               <div v-for="(uid, index) in uidList" :key="index" class="dialog-item">
                  <span>{{ uid }}</span>
                  <el-button type="text" icon="circle-close" @click="handleDeleteUid(index)"></el-button>
               </div>
            </div>
            <div class="card-footer">
               共计 {{ uidList.length }} 个用户
            </div>
         </el-form-item>
      </el-form>

      <template #footer>
         <div class="flex-row-center">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="clickEditDone">确定</el-button>
         </div>
      </template>
   </el-dialog>
</template>

<script>
const LOG_TAG = 'Debug用户';

export default {
   props: {
      dialogTitle: {
         type: String,
         default: ''
      },
      dataSource: {
         type: Object,
         default: () => ({})
      }
   },

   data() {
      return {
         dialogVisible: false,
         inputUid: '',
         uidList: []  // 已确认的 uid 集合
      };
   },

   methods: {
      sendUpdate() {
         const uidValues = this.uidList.map((v) => Number(v));
         const resValue = { uid: uidValues };

         const param = {
            tag: this.dataSource.tag,
            key: this.dataSource.resKey,
            value: JSON.stringify(resValue)
         };

         this.$http({
            url: this.$util.domain + '/adminapi/v1/tools/addOrUpdateConfig',
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(param)
         }).then((res) => {
            if (res.data.error === 10000) {
               this.dialogVisible = false;
               this.$emit('refresh');
            } else {
               this.$util.errorMsg(res.message || '保存失败');
            }
         }).catch((error) => {
            console.log(LOG_TAG + '-保存失败:', error);
            this.$util.errorMsg('保存失败');
         });
      },

      clickEdit() {
         this.inputUid = '';
         this.uidList = [];
         if (this.dataSource.resValue && this.dataSource.resValue !== '') {
            try {
               const resValue = JSON.parse(this.dataSource.resValue);
               if (resValue.uid && Array.isArray(resValue.uid) && resValue.uid.length > 0) {
                  this.uidList = resValue.uid.map((v) => String(v));
               }
            } catch (error) {
               console.log(LOG_TAG + '-解析数据失败:', error);
            }
         }
         this.dialogVisible = true;
      },

      handleAddUid() {
         const uid = this.inputUid.trim();
         if (!uid) return;
         const num = Number(uid);
         if (Number.isNaN(num) || num <= 0) {
            this.$util.errorMsg('请输入有效的用户 ID（正整数）');
            return;
         }
         if (this.uidList.includes(uid)) {
            this.$util.errorMsg('该 UID 已添加');
            return;
         }
         this.uidList.push(uid);
         this.inputUid = '';
      },

      handleDeleteUid(index) {
         this.uidList.splice(index, 1);
      },

      close() {
         this.inputUid = '';
         this.uidList = [];
      },

      clickEditDone() {
         this.sendUpdate();
      }
   }
};
</script>

<style scoped>
.card-wrap {
   box-sizing: border-box;
   width: 100%;
   height: 200px;
   overflow: auto;
   padding: 10px;
   margin: 8px 0 4px;
   border: 1px solid #c0ccda;
   border-radius: 4px;
   font-size: 14px;
   line-height: 1.5;
}

.dialog-item {
   display: inline-block;
   margin: 0 4px 4px;
   padding: 4px;
   border: 1px solid #c0ccda;
   border-radius: 4px;
   font-size: 14px;
   line-height: 1.5;
}

.card-footer {
   text-align: right;
   font-size: 14px;
   line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// DebugUser.vue?57935b5e